// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"deb69b5d","732":"96171e2b","977":"16204015"}[chunkId] + ".chunk.js";
};